import { isDefined } from './undefined';

export default function assertAllElementsAreDefined<T>(arr: T[], name = 'array')
    : asserts arr is Exclude<T, undefined>[] {
    if (!arr.every(isDefined)) {
        throw new TypeError(`All elements of ${name} must be defined`);
    }
}
